var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.9787 40.8182V5.01755C58.9787 3.95203 58.5576 2.93015 57.8081 2.17671C57.0585 1.42328 56.0419 1 54.9819 1H11.018C9.95805 1 8.94147 1.42328 8.19194 2.17671C7.44241 2.93015 7.02133 3.95203 7.02133 5.01755V40.8182M58.9787 40.8182H7.02133M58.9787 40.8182L64.0785 47.6866C64.3829 48.299 64.5266 48.9794 64.4959 49.6632C64.4653 50.3471 64.2613 51.0117 63.9034 51.5941C63.5455 52.1765 63.0454 52.6573 62.4507 52.9908C61.856 53.3244 61.1864 53.4996 60.5054 53.5H5.49459C4.81358 53.4996 4.14396 53.3244 3.54927 52.9908C2.95458 52.6573 2.45454 52.1765 2.0966 51.5941C1.73866 51.0117 1.53469 50.3471 1.50405 49.6632C1.47341 48.9794 1.61711 48.299 1.92152 47.6866L7.02133 40.8182",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.25 12.8501L32.3626 14.151V20.7432L41.25 20.6725V12.8501ZM24.7549 21.4585L24.7553 27.0681L31.4926 27.9919L31.4873 21.5021L24.7549 21.4585ZM32.2919 21.5484L32.3044 28.0921L41.2416 29.3501L41.2438 21.5631L32.2919 21.5484ZM24.75 15.1863L24.7562 20.7932L31.4935 20.755L31.4905 14.2706L24.75 15.1863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_3878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(24 12.1001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/Windows.c2c6d301ef4f85e054f73071ce508569.svg";
export { ForwardRef as ReactComponent };